import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'returnsUnsavedChangesModal.title',
    defaultMessage: 'Warning',
    id: 'SfNZ87',
  },
  modalContent: {
    defaultMessage: 'The return you started will not be saved until a return label is created. Exit anyway?',
    description: 'returnsUnsavedChangesModal.content',
    id: 'SF/JpB',
  },
  continueButton: {
    defaultMessage: 'Continue',
    description: 'returnsUnsavedChangesModal.continue',
    id: '0uiCp0',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'returnsUnsavedChangesModal.cancel',
    id: 'NmXNRD',
  },
});
